<template>
    <div class="edit">
        <div class="flex align-center title">
            <span class="fs_28 c_98">联系人</span>
        </div>
        <div class="flex__between__center item bb_1">
            <span class="fs_28 c_1a">姓名</span>
            <input class="fs_28" v-model="creates.linkman" type="text" placeholder="请填写收货人姓名">
        </div>
        <div class="flex__between__center item">
            <span class="fs_28 c_1a">手机</span>
            <input class="fs_28" v-model="creates.mobile_phone" type="number" placeholder="请填写收货手机号码">
        </div>
        <div class="flex align-center title">
            <span class="fs_28 c_98">收货地址</span>
        </div>
        <div class="flex__between__center item bb_1" @click="picker_show=true">
            <span class="fs_28 c_1a">所在地区</span>
            <div>
                <span class="fs_28 c_1a">&ensp;{{address}}</span>
                <span class="jcicon jcicon-xiala1 fs_20 c_b3"></span>
            </div>
        </div>
        <div class="flex__between__center item">
            <input class="fs_28" v-model="creates.address" type="text" placeholder="请填写详细地址">
            <span class="fs_38 jcicon jcicon-ditu1 c_main" @click="bMap=true"></span>
        </div>
        <div class="flex__between__center item mt_15">
            <span class="fs_28 c_1a">设为默认</span>
            <span class="jcicon jcicon-unselected fs_34 c_98" v-if="creates.is_default==1" @click="creates.is_default=2"></span>
            <span class="jcicon jcicon-dui fs_34 c_main" v-else @click="creates.is_default=1"></span>
        </div>
        <div class="footer">
            <button @click="createAddress">保存</button>
        </div>
        <div class="picker-box" v-show="picker_show">
            <div class="layer" @click="picker_show=false"></div>
            <van-picker 
            class="van-picker" 
            ref="picker" 
            show-toolbar 
            :columns="columns" 
            value-key="name" 
            @change="cityChange"
            @cancel="picker_show=false"
            @confirm="setAddress"
             />
        </div>
        <iframe id="mapPage" width="100%" height="100%" frameborder=0 v-show="bMap"
              src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp">
        </iframe>
    </div>
</template>
<script>
export default {
    name: "Edit",
    data(){
        return{
            picker_show: false,
            bMap: false,
            provinces: [],
            citys: [],
            areas: [],
            address: '',
            creates:{
                openid:localStorage.openid,
                user_id: localStorage.user_id,
                id: '',
                is_default: 1,
                linkman: '',
                mobile_phone: '',
                address: '',
                province_id: '',
                city_id: '',
                area_id: ''
            },
            columns: [
                {
                    values: [],
                    className: 'column1'
                },
                {
                    values: [],
                    className: 'column2',
                    defaultIndex: 1
                },
                {
                    values: [],
                    className: 'column3',
                    defaultIndex: 2
                }
            ]
        }
    },
    methods:{
         // 处理省市县联动逻辑
        cityChange: function(picker,values) {
            let provinces = this.provinces
            let citys = this.citys
            let areas = this.areas
            // 如果省份选择项和之前不一样，表示滑动了省份，此时市默认是省的第一组数据，
            if (values[0].id != this.creates.province_id) {
                let id = values[0].id;
                this.creates.province_id=id;
                if (citys[id].length){
                    let idd = citys[id][0].id;
                    this.creates.city_id=idd;
                    picker.setColumnValues(0, provinces);
                    picker.setColumnValues(1, citys[id]);
                    picker.setColumnValues(2, areas[idd]);
                }else{
                    picker.setColumnValues(1, citys[id]);
                    picker.setColumnValues(2, []);
                }
            } else if (values[1].id != this.creates.city_id) {
               // 滑动选择了第二项数据，即市，此时区显示省市对应的第一组数据
                picker.setColumnValues(2, values[1].area);
            }
        },
        // 确定
        setAddress(values){
            this.picker_show=false;
            this.creates.province_id=values[0].id;
            this.creates.city_id=values[1].id;
            this.creates.area_id=values[2].id;
            this.address=values[0].name+values[1].name+values[2].name;
        },
        // create
        createAddress(){
            for(let key in this.creates){
                if(!this.creates[key]&&key!='id'){
                    this.$toast('请将信息填写完整');
                    return;
                }
            }
            this.axios.post('/wechat.php/Address/addressEdit',this.creates).then(
                res=>{
                    if(res.data.code==1){
                        this.$dialog.alert({
                            message: res.data.message
                        }).then(() => {
                            this.$router.go(-1);
                        });
                    }else{
                        this.$toast(res.data.message);
                    }
                }
            )
        },
        // 获取地址
        getAddress(param_id){
            this.axios.post('/wechat.php/Address/getAddressData', {
                openid:localStorage.openid,
                user_id: localStorage.user_id,
                id: param_id
            }).then(
                res=>{
                    // 编辑渲染
                    this.address=res.data.data.province+res.data.data.city+res.data.data.area;
                    this.creates.address=res.data.data.address;
                    this.creates.linkman=res.data.data.linkman;
                    this.creates.mobile_phone=res.data.data.mobile_phone;
                    this.creates.id=res.data.data.id;
                    this.creates.province_id=res.data.data.province_id;
                    this.creates.city_id=res.data.data.city_id;
                    this.creates.area_id=res.data.data.area_id;
                    this.creates.is_default=res.data.data.is_default;
                    // 设置picker
                    let id = res.data.data.province_id;
                    this.$refs.picker.setColumnValues(0, this.provinces);
                    this.$refs.picker.setColumnValues(1, this.citys[id]);
                    this.$refs.picker.setColumnValues(2, this.areas[this.citys[id][0].id]);
                    this.$refs.picker.setColumnValue(0, res.data.data.province);
                    this.$refs.picker.setColumnValue(1, res.data.data.city);
                    this.$refs.picker.setColumnValue(2, res.data.data.area);
                }
            )
        }
    },
    mounted(){
        const that=this;
        window.addEventListener('message', function (event) {
            // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
            let loc = event.data;
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            if (loc && loc.module == 'locationPicker') {
                that.bMap = false;
                that.creates.address = loc.poiname;
            }
        }, false);
        
        this.axios.post('/wechat.php/Address/getRegionAll',{
            openid:localStorage.openid,
            user_id: localStorage.user_id,
            get_long_lat:0  // 1：需要 2：不需要 0：不需要(lat 纬度lng 经度)
        }).then(
            res=>{
                if(res.data.code==1){
                    let addressArray=res.data.data.area;
                    let cityy = []; //返回的数组 市
                    let areass = []; //返回的数组 区
                    let subprovince = {}
                    for (let i = 0; i < addressArray.length; i++) {
                        subprovince = {
                            id: i + 1,
                            name: addressArray[i].name
                        }
                        this.provinces.push(subprovince); //属性
                    }
                    for (let i = 0; i < addressArray.length; i++) {
                        cityy.push(addressArray[i].city); //属性
                    }
                    for (let i = 0; i < cityy.length; i++) {
                        for (let ii = 0; ii < cityy[i].length; ii++) {
                            areass.push(cityy[i][ii].area); //属性
                        }
                    }
                    // 不知道你们怎么想的，我是硬配合
                    this.citys[0]={id:'',name:''};
                    for (let i = 0; i < cityy.length; i++) {
                        this.citys[i + 1] = cityy[i]
                    }
                    let areas = {}
                    this.areas[0]={id:'',name:''};
                    for (let i = 0; i < areass.length; i++) {
                        this.areas[i + 1] = areass[i]
                    }
                    // 新建或编辑
                    if(this.$route.params.id!=0){
                        this.getAddress(this.$route.params.id);
                    }else{
                        // 新建
                        let id = this.provinces[0].id;
                        this.$refs.picker.setColumnValues(0, this.provinces);
                        this.$refs.picker.setColumnValues(1, this.citys[id]);
                        this.$refs.picker.setColumnValues(2, this.areas[this.citys[id][0].id]);
                    }
                }
            }
        )
    }
}
</script>
<style scoped>
.title{
    height: 90px;
    padding: 0 30px;
}
.item{
    height: 100px;
    padding: 0 30px;
    background: #fff;
}
.item input{
    width: 600px;
}
.mt_15{
    margin-top: 15px;
}
iframe{
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100%;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
}
.footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
/* picker */
.picker-box{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 1;
}
.layer{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 1;
}
.van-picker{
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/address/Edit.vue